import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PanarottisIcon from '../../data/PanaImages/PanarottisIcon.png';
import CounterPaymentImage from '../../data/PanaImages/CounterPayment.png';
import { setCurrentScreen } from '../../store/orderSlice';
import { RootState } from '../../store';

const nexaRustStack = '"Nexa Rust Sans Black A", "Museo Sans", ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif';

const PayAtCounterScreen: React.FC = () => {
  const dispatch = useDispatch();
  const orderNumber = useSelector((state: RootState) => state.order.currentOrderNumber);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      dispatch(setCurrentScreen('success'));
    }, 5000);

    return () => window.clearTimeout(timer);
  }, [dispatch]);

  const handleAdvance = () => {
    dispatch(setCurrentScreen('success'));
  };

  return (
    <div
      className="min-h-screen bg-[#f2f1ec] flex flex-col items-center px-10 pt-12 pb-12"
      role="presentation"
      onClick={handleAdvance}
    >
      <img
        src={PanarottisIcon}
        alt="Panarottis"
        className="w-[100px] h-[75.76px] object-contain"
      />

      <h1
        className="mt-12 text-center uppercase text-[#185C53] max-w-[1080px]"
        style={{
          fontFamily: nexaRustStack,
          fontSize: '80px',
          lineHeight: '88px',
          fontWeight: 900,
          letterSpacing: '2px',
        }}
      >
        Order <span style={{ color: '#00A294' }}>#{orderNumber ?? '-----'}</span>
        <br />
        Take your receipt to the counter
      </h1>

      <img
        src={CounterPaymentImage}
        alt="Take your receipt to the counter"
        className="mt-20 w-[500px] h-[519.01px] object-contain"
      />
    </div>
  );
};

export default PayAtCounterScreen;

